"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomGridFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
require("../../../../css/documentManagement.css");
var _Filter = require("./Filter");
var _Sort = require("./Sort");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CustomGridFilter = exports.CustomGridFilter = function CustomGridFilter(_ref) {
  var columnName = _ref.columnName,
    sortable = _ref.sortable,
    filterable = _ref.filterable,
    data = _ref.data,
    callbackApplyFilters = _ref.callbackApplyFilters,
    initialSort = _ref.initialSort,
    _ref$initialFilters = _ref.initialFilters,
    initialFilters = _ref$initialFilters === void 0 ? [] : _ref$initialFilters;
  // Memoize initial values to prevent infinite loops
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var memoizedInitialFilters = (0, _react.useMemo)(function () {
    return initialFilters;
  }, [JSON.stringify(initialFilters)]);
  var memoizedInitialSort = (0, _react.useMemo)(function () {
    return initialSort;
  }, [initialSort]);
  // Internal state for menu control
  var _React$useState = _react["default"].useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalAnchorEl = _React$useState2[0],
    setInternalAnchorEl = _React$useState2[1];
  var internalOpen = Boolean(internalAnchorEl);
  var _useState = (0, _react.useState)(memoizedInitialFilters),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItems = _useState2[0],
    setSelectedItems = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      // Convert from asc/desc to ascending/descending for internal state
      if (memoizedInitialSort === "asc") return "ascending";
      if (memoizedInitialSort === "desc") return "descending";
      return "";
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSort = _useState4[0],
    setSelectedSort = _useState4[1];

  // Sync internal state with initial props when they change - use memoized values
  (0, _react.useEffect)(function () {
    setSelectedItems(memoizedInitialFilters);
  }, [memoizedInitialFilters]);
  (0, _react.useEffect)(function () {
    // Convert from asc/desc to ascending/descending for internal state
    var convertedSort = mapSortToAscdesc(memoizedInitialSort || "");
    setSelectedSort(convertedSort);
  }, [memoizedInitialSort]);
  (0, _react.useEffect)(function () {
    if (!initialSort && initialFilters.length === 0 && !internalAnchorEl) {
      setSelectedItems([]);
      setSelectedSort("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalAnchorEl]);

  // Helper functions to convert between sort formats
  var mapSortToAscdesc = function mapSortToAscdesc(sort) {
    if (sort === "asc") return "ascending";
    if (sort === "desc") return "descending";
    return "";
  };
  var mapAscdescToSort = function mapAscdescToSort(ascdesc) {
    if (ascdesc === "ascending") return "asc";
    if (ascdesc === "descending") return "desc";
    return "";
  };
  var handleFilterClick = function handleFilterClick(event) {
    setInternalAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setInternalAnchorEl(null);
  };
  var handleApply = function handleApply() {
    var convertedSort = mapAscdescToSort(selectedSort);
    callbackApplyFilters({
      sort: convertedSort,
      filters: selectedItems
    });
    setInternalAnchorEl(null);
  };
  var handleCancel = function handleCancel() {
    setInternalAnchorEl(null);
  };
  var theme = (0, _material.useTheme)();
  var iconColor = initialSort != "" || initialFilters.length > 0 ? theme.palette.primary.main : "black";
  var handleReset = function handleReset() {
    setSelectedItems([]);
    setSelectedSort("");
    callbackApplyFilters({
      sort: "",
      filters: []
    });
    setInternalAnchorEl(null);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "column_header_container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    "data-testid": "menu_open",
    onClick: handleFilterClick,
    className: "row_header_btn",
    style: {
      minWidth: "200px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex gap-10 align-items-center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    fontWeight: "bold"
  }, columnName), initialFilters.length > 0 && /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "mingcute:filter-line",
    width: "15",
    height: "15",
    color: iconColor
  }), initialSort != "" && /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "solar:arrow-down-outline",
    width: "15",
    height: "15",
    color: iconColor
  })), /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bxs:down-arrow",
    width: "10",
    height: "10",
    color: iconColor
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "action_menu",
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Menu, {
    id: "basic-menu",
    anchorEl: internalAnchorEl,
    open: internalOpen,
    onClose: handleClose,
    slotProps: {
      paper: {
        "aria-labelledby": "basic-button"
      }
    },
    sx: {
      "& .MuiPaper-root": {
        boxShadow: "1px 2px 2px rgba(0, 0, 0, 0.5)"
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column gap-10 filter_container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column width-100"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between"
  }, sortable && /*#__PURE__*/_react["default"].createElement("h2", null, "Sort"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleClose,
    className: "close_icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 20,
    color: "black"
  }))), sortable && /*#__PURE__*/_react["default"].createElement(_Sort.Sort, {
    selectedButton: selectedSort,
    handleSortClick: function handleSortClick(sort) {
      setSelectedSort(sort);
    }
  })), filterable && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h2", null, "Filter"), /*#__PURE__*/_react["default"].createElement(_Filter.Filter, {
    data: data,
    initialSelected: selectedItems,
    callbackSelected: function callbackSelected(selected) {
      return setSelectedItems(selected);
    }
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "reset_btn_filter",
    onClick: handleReset,
    disabled: selectedItems.length === 0 && selectedSort === ""
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Reset")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter_footer"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleCancel,
    className: "btn filter_cancel"
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleApply,
    className: "btn filter_apply"
  }, "Apply"))))));
};